import React from 'react'
import Show from 'services/Show';
import { formatDate } from 'services/utils'
import './show_catalog_recipients.sass';
import { Spinner } from 'components/atoms';
import PrinterSelect from 'components/PrinterSelect';
import PrintButton from 'components/PrintButton';

export default class ShowCatalogRecipients extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      dogs: [],
      sortBy: '',
      showId: match.params.id,
    }
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.getCatalogRecipients(this.state.showId).then(({show, dogs}) => {
      if (this.mounted) {
        this.setState({ show: new Show(show), dogs });
      }
    }).catch(alert).then(() => {
      if (this.mounted) {
        this.setState({loading: false});
      }
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  sortList = ({target}) => {
    const sortBy = target.value;
    this.setState({sortBy})
    if (!sortBy) return;
    const dogs = [...this.state.dogs].sort((a,b) => a[sortBy] > b[sortBy] ? 1 : (a[sortBy] < b[sortBy] ? -1 : 0) );
    this.setState({dogs});
  }

  renderRecipients() {
    if (!this.state.dogs) return null;
    return this.state.dogs.map((dog, i) => (<tr key={dog.id}>
      <td>{i+1}</td>
      <td className="owner-name">{dog.owner_name}</td>
      <td className="dog-number">{dog.catalog_number}</td>
      <td className="dog-breed">{dog.breed_name}</td>
      <td className="dog-name">{dog.name}</td>
    </tr>) );
  }

  render() {
    const {show, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    if (!show || loading) {
      return (
        <div className="container-fluid">
          <h4>Список участников, запросивших каталог - {showInfo}</h4>
          {loading && <Spinner /> }
        </div>
      )
    }
    const recipients = this.renderRecipients();

    return (
      <div className="container-fluid">
        <div className="no-print">
          <div className="row">
            <div className="col-2">
              <label>Принтер</label>
              <PrinterSelect className="form-control"/>
            </div>
            <div className="col-1">
              <label className="row">&nbsp;</label>
              <PrintButton disabled={!recipients} />
            </div>
            <div className="col-1">
              <label>Отсортировать по </label>
              <select value={this.state.sortBy} onChange={this.sortList} className="form-control">
                <option value=""></option>
                <option value="owner_name">Владельцу</option>
                <option value="catalog_number">Номеру в каталоге</option>
                <option value="name">Кличке</option>
                <option value="breed_name">Породе</option>
              </select>
            </div>
          </div>
          <br />
          <br />
        </div>
        <h4>Список участников, запросивших каталог - {showInfo}</h4>
        <table id="recipients">
          <tr>
            <th></th>
            <th>Владелец</th>
            <th>N</th>
            <th>Порода</th>
            <th>Кличка</th>
          </tr>
          {recipients}
        </table>
      
      </div>
    );
  }
}